var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2204_77",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#474747"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2204_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C10.95 22.5 10.0625 22.1375 9.3375 21.4125C8.6125 20.6875 8.25 19.8 8.25 18.75C8.25 17.8833 8.50833 17.1208 9.025 16.4625C9.54167 15.8042 10.2 15.3583 11 15.125V13H5V9H2.5V2H9.5V9H7V11H17V8.875C16.2 8.64167 15.5417 8.19583 15.025 7.5375C14.5083 6.87917 14.25 6.11667 14.25 5.25C14.25 4.2 14.6125 3.3125 15.3375 2.5875C16.0625 1.8625 16.95 1.5 18 1.5C19.05 1.5 19.9375 1.8625 20.6625 2.5875C21.3875 3.3125 21.75 4.2 21.75 5.25C21.75 6.11667 21.4917 6.87917 20.975 7.5375C20.4583 8.19583 19.8 8.64167 19 8.875V13H13V15.125C13.8 15.3583 14.4583 15.8042 14.975 16.4625C15.4917 17.1208 15.75 17.8833 15.75 18.75C15.75 19.8 15.3875 20.6875 14.6625 21.4125C13.9375 22.1375 13.05 22.5 12 22.5Z",
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallFlow);
export default __webpack_public_path__ + "static/media/CallFlow.95e79744baba9fd6878db50bdb208e35.svg";
export { ForwardRef as ReactComponent };